import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import { Link } from "react-router-dom";
import { statusList2 } from "@/utils/constant";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Button,
    Table,
    message,
    Modal,
    Select,
    InputNumber,
    Form,
    Radio,
    DatePicker,
    Slider,
    Row,
    Card,
} from "antd";

/**
 * 禁用之前日期
 */
const disabledDate = (current) => {
    return current < moment().startOf("day");
};

const formData = {
    // 表单数据
    kind: 1,
    level: [0, 0],
    round_duration: 0,
    round_num: 0,
    round_bonus: 1000,
    begin_time: moment().add(10, "minutes"),
};

export default class ActivityHighHandCard extends React.Component {
    state = {
        loading: false, // 是否加载中
        recordLoading: false, // 记录是否加载中
        show: false, // 添加弹窗
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            status: undefined,
        },
        recordQueryParams: {
            // 记录查询参数
            page: 1,
            limit: 20,
            total: 0,
        },
        statusList: statusList2, // 状态列表
        formData: formData, // 表单数据
        data: [], // 表格数据
        configData: {}, // 配置数据
        recordData: [], // 记录数据
        recordInfo: [], // 记录详情
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/activity_high_hand_card_list", {
                params: {
                    ...this.state.queryParams,
                    status:
                        this.state.queryParams.status !== undefined
                            ? this.state.queryParams.status
                            : -1,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取配置数据
     */
    fetchConfigData = () => {
        axios.get("/v1/api/activity_high_hand_card_conf").then((res) => {
            this.setState({
                configData: res.data || {},
            });
        });
    };

    /**
     * 获取记录数据
     */
    fetchRecordData = () => {
        this.setState({ recordLoading: true });
        axios
            .get("/v1/api/activity_high_hand_card_round_list", {
                params: {
                    ...this.state.recordQueryParams,
                    active_id: this.state.recordInfo.active_id,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    recordLoading: false,
                    recordQueryParams: {
                        ...this.state.recordQueryParams,
                        total: res.count || 0,
                    },
                    recordData: res.data || [],
                });
            });
    };

    /**
     * 添加
     */
    handleAdd = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (
                    this.state.configData.round_num_list[values.round_num] *
                    values.round_bonus >
                    this.state.configData.super_union_point
                )
                    return message.error(
                        this.props.language["insufficientPointsMessage"]
                    );
                axios
                    .post("/v1/api/activity_create_high_hand_card", {
                        kind: values.kind,
                        begin_level: this.state.configData.blinds[values.level[0]].bb,
                        end_level: this.state.configData.blinds[values.level[1]].bb,
                        round_duration:
                            this.state.configData.round_duration_list[values.round_duration],
                        round_num: this.state.configData.round_num_list[values.round_num],
                        round_bonus: values.round_bonus,
                        begin_time: parseInt(new Date(values.begin_time).getTime() / 1000),
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(this.props.language["createSuccessMessage"]);
                            this.handleReset();
                            this.handleClose();
                        }
                    });
            }
        });
    };

    /**
     * 下线活动
     */
    handleOffLine = (id) => {
        Modal.confirm({
            title: this.props.language["hint"],
            content: this.props.language["offlineActivityConfirm"],
            onOk: () => {
                axios
                    .delete(`/v1/api/activity_close_high_hand_card/${id}`)
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(this.props.language["offlineSuccessMessage"]);
                            this.fetchData();
                        }
                    });
            },
        });
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        let title;
        switch (type) {
            case "add":
                title = this.props.language["createHighHandCard"];
                this.fetchConfigData();
                break;
            case "view":
                title = this.props.language["activityRecord"];
                this.setState(
                    {
                        recordInfo: item,
                        recordData: [],
                        recordQueryParams: {
                            ...this.state.recordQueryParams,
                            page: 1,
                        },
                    },
                    () => this.fetchRecordData()
                );
                break;
        }
        this.setState({ show: true, type, title });
    };

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields();
        this.setState({ show: false });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (type, pagination) => {
        if (type === "data") {
            // 数据分页
            this.setState(
                {
                    queryParams: { ...this.state.queryParams, page: pagination.current },
                },
                () => this.fetchData()
            );
        } else if (type === "record") {
            // 记录分页
            this.setState(
                {
                    recordQueryParams: {
                        ...this.state.recordQueryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchRecordData()
            );
        }
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    status: undefined,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["statusPlaceholder"]}
                        value={this.state.queryParams.status}
                        onChange={(value) => this.handleSetQueryParamsData("status", value)}
                    >
                        {this.state.statusList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button type="primary" ghost onClick={() => this.handleShow("add")}>
                        {this.props.language["createHighHandCard"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={(page) => this.hanldeChangePage("data", page)}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["activityId"]}
                            dataIndex="active_id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["status"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.statusList.find(
                                    (statusItem) => statusItem.value == item.status
                                )
                                    ? this.state.statusList.find(
                                        (statusItem) => statusItem.value == item.status
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameType"]}
                            dataIndex="game_kind"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["levelRange"]}
                            dataIndex="level"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["startTime"]}
                            dataIndex="begin_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["endTime"]}
                            dataIndex="end_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["currentRound"]}
                            dataIndex="current_round"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalRound"]}
                            dataIndex="round_num"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["singlePrize"]}
                            dataIndex="round_bonus"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalPrize"]}
                            dataIndex="total_bonus"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["alreadyWinnPeople"]}
                            dataIndex="bonus_players"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["alreadyPrize"]}
                            dataIndex="bonus_amount"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={200}
                            render={(item) => (
                                <>
                                    <Button
                                        type="default"
                                        onClick={() => this.handleShow("view", item)}
                                    >
                                        {this.props.language["activityRecord"]}
                                    </Button>
                                    <Button
                                        className="ml10"
                                        type="danger"
                                        ghost
                                        disabled={item.status === 2 || item.status === 3}
                                        onClick={() => this.handleOffLine(item.active_id)}
                                    >
                                        {this.props.language["offLine"]}
                                    </Button>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 弹窗内容 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    recordLoading={this.state.recordLoading}
                    recordQueryParams={this.state.recordQueryParams}
                    recordData={this.state.recordData}
                    recordInfo={this.state.recordInfo}
                    configData={this.state.configData}
                    formData={this.state.formData}
                    onOk={this.handleAdd}
                    onCancel={this.handleClose}
                    hanldeChangePage={this.hanldeChangePage}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        );
    }
}

/**
 * 弹窗内容
 */
const FormModal = Form.create({ name: "form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form;

            return (
                <Modal
                    maskClosable={false}
                    width={this.props.type === "add" ? 600 : 1600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                    footer={
                        this.props.type === "add" ? (
                            <>
                                <Button type="default" onClick={this.props.onCancel}>
                                    {this.props.language["cancel"]}
                                </Button>
                                <Button type="primary" onClick={this.props.onOk}>
                                    {this.props.language["confirm"]}
                                </Button>
                            </>
                        ) : (
                            false
                        )}
                >
                    <div className="container-content">
                        {/* 新增 */}
                        {this.props.type === "add" && this.props.configData.games && (
                            <Form>
                                <Form.Item label={this.props.language["gameType"]}>
                                    {getFieldDecorator("kind", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["gameTypeVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.kind,
                                    })(
                                        <Radio.Group>
                                            {this.props.configData.games.map((item, index) => (
                                                <Radio key={index} value={item.kind}>
                                                    {item.name}
                                                </Radio>
                                            ))}
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <span>
                                            {this.props.language["levelRange"]}
                                            {this.props.language["levelFix"]}：
                                            {this.props.configData.blinds[
                                                getFieldValue("level")
                                                    ? getFieldValue("level")[0]
                                                    : this.props.formData.level[0]
                                            ].bb / 100}
                                            -
                                            {this.props.configData.blinds[
                                                getFieldValue("level")
                                                    ? getFieldValue("level")[1]
                                                    : this.props.formData.level[1]
                                            ].bb / 100}
                                        </span>
                                    }
                                >
                                    {getFieldDecorator("level", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["levelRangeVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.level,
                                    })(
                                        <Slider
                                            dots
                                            range
                                            tipFormatter={(value) =>
                                                this.props.configData.blinds[value].bb / 100
                                            }
                                            min={0}
                                            max={this.props.configData.blinds.length - 1}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <span>
                                            {this.props.language["roundTime"]}：
                                            {
                                                this.props.configData.round_duration_list[
                                                getFieldValue("round_duration") ||
                                                this.props.formData.round_duration
                                                ]
                                            }
                                            h
                                        </span>
                                    }
                                >
                                    {getFieldDecorator("round_duration", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["roundTimeVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.round_duration,
                                    })(
                                        <Slider
                                            dots
                                            tipFormatter={(value) =>
                                                this.props.configData.round_duration_list[value] + "h"
                                            }
                                            min={0}
                                            max={this.props.configData.round_duration_list.length - 1}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <span>
                                            {this.props.language["roundAmount"]}：
                                            {
                                                this.props.configData.round_num_list[
                                                getFieldValue("round_num") ||
                                                this.props.formData.round_num
                                                ]
                                            }
                                        </span>
                                    }
                                >
                                    {getFieldDecorator("round_num", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["roundAmountVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.round_num,
                                    })(
                                        <Slider
                                            dots
                                            tipFormatter={(value) =>
                                                this.props.configData.round_num_list[value]
                                            }
                                            min={0}
                                            max={this.props.configData.round_num_list.length - 1}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <>
                                            <span>
                                                {this.props.getLanguage(
                                                    "roundBonus",
                                                    this.props.configData.round_num_list[
                                                    getFieldValue("round_num") ||
                                                    this.props.formData.round_num
                                                    ] *
                                                    (getFieldValue("round_bonus") !== undefined
                                                        ? getFieldValue("round_bonus")
                                                        : this.props.formData.round_bonus)
                                                )}
                                            </span>
                                            <span className="ml20">
                                                {this.props.language["counterPoint"]}：
                                                {this.props.configData.super_union_point}
                                            </span>
                                        </>
                                    }
                                >
                                    {getFieldDecorator("round_bonus", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["roundBonusVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.round_bonus,
                                    })(
                                        <InputNumber
                                            min={1}
                                            max={100000000}
                                            precision={0}
                                            placeholder={this.props.language["roundBonusPlaceholder"]}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item label={this.props.language["startTime"]}>
                                    {getFieldDecorator("begin_time", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["startTimeVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.begin_time,
                                    })(
                                        <DatePicker
                                            disabledDate={disabledDate}
                                            showTime={{ format: "HH:mm" }}
                                            format="YYYY-MM-DD HH:mm"
                                            placeholder={this.props.language["startTimePlaceholder"]}
                                        />
                                    )}
                                </Form.Item>
                            </Form>
                        )}

                        {/* 活动记录 */}
                        {this.props.type === "view" && (
                            <>
                                {/* 基本信息 */}
                                <Card
                                    title={
                                        <h2>
                                            {this.props.language["basicInfo"]}
                                        </h2>
                                    }
                                    type="inner"
                                >
                                    <Table
                                        dataSource={[this.props.recordInfo]}
                                        pagination={false}
                                        scroll={{ x: true }}
                                        rowKey={(record, index) => index}
                                    >
                                        <Table.Column align="center" title={this.props.language["activityId"]} dataIndex="active_id" />
                                        <Table.Column align="center" title={this.props.language["game"]} dataIndex="game_kind" />
                                        <Table.Column align="center" title={this.props.language["levelRange"]} dataIndex="level" />
                                        <Table.Column align="center" title={this.props.language["time"]} render={(item) => `${item.begin_time} ~ ${item.end_time}`} />
                                    </Table>
                                </Card>


                                {/* 中奖玩家 */}
                                <Card
                                    title={
                                        <h2>
                                            {this.props.language["winnerPlayer"]}
                                        </h2>
                                    }
                                    type="inner"
                                    className="mt20"
                                >
                                    <Table
                                        dataSource={this.props.recordData}
                                        pagination={{
                                            showTotal: (total) =>
                                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                                            showQuickJumper: true,
                                            current: this.props.recordQueryParams.page,
                                            pageSize: this.props.recordQueryParams.limit,
                                            total: this.props.recordQueryParams.total,
                                            size: isMobileDevice() ? 'small' : '',
                                        }}
                                        loading={this.props.recordLoading}
                                        onChange={(page) => this.props.hanldeChangePage("record", page)}
                                        scroll={{ x: true }}
                                        rowKey={(record, index) => index}
                                    >
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["round"]}
                                            dataIndex="round_id"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["currentRoundEndTime"]}
                                            dataIndex="end_time"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["winPrizeTime"]}
                                            dataIndex="bonus_time"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["winPrizePlayerId"]}
                                            dataIndex="uid"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["winrizePlayerName"]}
                                            dataIndex="name"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["cardType"]}
                                            dataIndex="cards"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["bonus"]}
                                            dataIndex="bonus"
                                        />
                                    </Table>
                                </Card>
                            </>
                        )}
                    </div>
                </Modal>
            );
        }
    }
);
